import { render, staticRenderFns } from "./TagTypes.vue?vue&type=template&id=737d49c0&scoped=true"
import script from "./TagTypes.vue?vue&type=script&lang=js"
export * from "./TagTypes.vue?vue&type=script&lang=js"
import style0 from "./TagTypes.vue?vue&type=style&index=0&id=737d49c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d49c0",
  null
  
)

export default component.exports